import { TreasuryService, TreasuryProvider, HttpService } from '@lk/api'

export const makeTreasuryService = (http: HttpService, baseUrl: string) =>
  new TreasuryService(new TreasuryProvider(http, baseUrl))
